import React, { FunctionComponent } from 'react';
import withStyles from 'react-jss';
import { useLazyQuery } from 'react-apollo';

import { ClassProp } from 'helpers/types';
import {
  handleError,
  handleSuccess,
} from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantOffers/MerchantOffer.helpers';
import Button from 'components/Button/Button';
import RESEND_TEMP_PASSWORD from './ResendTempPassword.queries';

type Styles = ClassProp<typeof styles>;

type Props = {
  onClick: () => Record<'email' | 'userStatus', string>;
  classes: Styles;
};

const styles = {
  reSendBtn: {
    borderRadius: '.3rem',
    color: '#fff !important',
  },
};

const userPoolId = process.env.COGNITO_USER_POOL_ID;

const defaultSuccessMessage = [
  {
    message: 'Successfully re-sent temporary password',
    displayMessage: 'Resend Temporary Password',
  },
];

const FORCE_CHANGE_PASSWORD = 'FORCE_CHANGE_PASSWORD';

const ResendTempPassword: FunctionComponent<Props> = (props) => {
  const { onClick: getUserAttributes, classes } = props;

  const { email, userStatus } = getUserAttributes();

  const handleResendTempPasswordResponse = () => {
    handleSuccess(defaultSuccessMessage);
  };

  const [resendTempPassword, { loading }] = useLazyQuery(RESEND_TEMP_PASSWORD, {
    fetchPolicy: 'no-cache',
    onError: handleError,
    onCompleted: handleResendTempPasswordResponse,
  });

  const onClickHandler = () => {
    resendTempPassword({
      variables: {
        params: {
          user: {
            userName: email,
            userPoolId,
          },
        },
      },
    });
  };

  return (
    <Button
      title="Resend Welcome"
      className={classes.reSendBtn}
      disabled={loading || !userPoolId || userStatus !== FORCE_CHANGE_PASSWORD}
      onClick={onClickHandler}
    ></Button>
  );
};

export default withStyles(styles)(ResendTempPassword);
